import { render } from "./NotificationPopup.vue?vue&type=template&id=dcde8e6e"
import script from "./NotificationPopup.vue?vue&type=script&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&lang=js"

import "./NotificationPopup.vue?vue&type=style&index=0&id=dcde8e6e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__